/* global $ */
import Swiper from 'swiper'
import { Navigation, Pagination, Autoplay, EffectFade } from 'swiper/modules'
import './swiper.css'

//Swiper.use([Navigation, Pagination, Autoplay])

function init () {
  $(document).ready(function () {
    // initialize swiper when document ready
    const heroSlider = $('.swiper-container.hero-slider')
    if(heroSlider.length > 0) {
      const swiper = new Swiper(heroSlider[0], {
        modules: [Navigation, Pagination, Autoplay, EffectFade],
        watchOverflow: true,
        autoHeight: false,
        centeredSlides: true,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false
        },
        pagination: {
          el: heroSlider.find('.swiper-pagination.hero-slider')[0],
          clickable: true
        },
        navigation: {
          nextEl: heroSlider.find('.swiper-button-next.hero-slider')[0],
          prevEl: heroSlider.find('.swiper-button-prev.hero-slider')[0]
        }
      })
      swiper.init()
    }
    const asiakasSlider = $('.swiper-container.asiakkaitamme')
    if(asiakasSlider.length > 0) {
      const swiper2 = new Swiper(asiakasSlider[0], {
        modules: [Navigation, Pagination, Autoplay, EffectFade],
        autoHeight: false,
        slidesPerView: 2,
        freeMode: true,
        spaceBetween: 70,
        autoplay: {
          delay: 2000,
          disableOnInteraction: false
        },
        pagination: {
          el: asiakasSlider.find('.swiper-pagination.asiakkaitamme')[0],
          clickable: true
        },
        navigation: {
          nextEl: asiakasSlider.find('.swiper-button-next.asiakkaitamme')[0],
          prevEl: asiakasSlider.find('.swiper-button-prev.asiakkaitamme')[0]
        },
        breakpoints: {
          630: {
            slidesPerView: 3,
            spaceBetween: 30,
          },
          850: {
            slidesPerView: 4
          },
          1000: {
            slidesPerView: 5,
            spaceBetween: 50
          }
        }
      })
      swiper2.init()
    }
  })
}

export default {
  init
}
